import { WithStatePaginatedTable } from '@delmonicos/shared-design-system-react/src/components/with-state-paginated-table/with-state-paginated-table';
import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { TransformedPaginatedData } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/transform-api-paginated-response/transformed-paginated-data.model';
import { OnChangeFn, SortingState } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { StateEnum } from '@model/enum/state.enum';

import {
  CUSTOMER_USER_LIST_COLUMN_LIST,
  CUSTOMER_USER_LIST_COLUMN_ORDER,
  CUSTOMER_USER_LIST_COLUMN_VISIBILITY,
} from './customer-user-list.config';

interface CustomerUserListViewProps {
  paginationLimit: number;
  paginationLimitList: number[];
  paginationState: StateEnum;
  paginationSorting: SortingState;
  resource?: TransformedPaginatedData<GatewayUserModel>;
  onPaginationLimitChange: (paginationLimitNext: number) => void;
  onPaginationPageChange: (paginationPageNext: number) => void;
  onPaginationSortingChange?: OnChangeFn<SortingState>;
}

export const CustomerUserListView = ({
  paginationLimit,
  paginationLimitList,
  paginationState,
  paginationSorting,
  resource,
  onPaginationLimitChange,
  onPaginationPageChange,
  onPaginationSortingChange,
}: CustomerUserListViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <WithStatePaginatedTable
      paginatedData={resource}
      state={paginationState}
      sorting={paginationSorting}
      columns={CUSTOMER_USER_LIST_COLUMN_LIST}
      columnOrder={CUSTOMER_USER_LIST_COLUMN_ORDER}
      columnVisibility={CUSTOMER_USER_LIST_COLUMN_VISIBILITY}
      limit={paginationLimit}
      limitList={paginationLimitList}
      errorMessage={t('$.user-list.error')}
      onLimitChange={onPaginationLimitChange}
      onPageChange={onPaginationPageChange}
      onSortingChange={onPaginationSortingChange}
    />
  );
};
